"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var common_1 = require("stremio/common");
var nextRequestId = 0;
var useMpvConfig = function () {
    var shell = (0, common_1.usePlatform)().shell;
    var t = (0, react_i18next_1.useTranslation)().t;
    var toast = (0, common_1.useToast)();
    var request = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(false), choosing = _a[0], setChoosing = _a[1];
    var path = shell.state.mpvConfig;
    (0, react_1.useEffect)(function () {
        var onSelected = function (_a) {
            var _b;
            var requestId = _a.requestId, path = _a.path, error = _a.error;
            if (((_b = request.current) === null || _b === void 0 ? void 0 : _b.id) !== requestId)
                return;
            var previousPath = request.current.path;
            request.current = null;
            setChoosing(false);
            if (error) {
                toast.show({ type: 'error', title: error, timeout: 5000 });
            }
            else if ((path || null) !== previousPath) {
                toast.show({ type: 'info', title: t('RESTART_REQUIRED_MESSAGE'), timeout: 5000 });
            }
        };
        shell.on('mpv-config-selected', onSelected);
        return function () {
            shell.off('mpv-config-selected', onSelected);
            request.current = null;
        };
    }, [shell.on, shell.off, t, toast]);
    var onSelect = function (value) {
        if (choosing)
            return;
        var id = ++nextRequestId;
        request.current = { id: id, path: path };
        setChoosing(true);
        shell.send(value === 'default' ? 'reset-mpv-config' : 'pick-mpv-config', { requestId: id });
    };
    return shell.capabilities.mpvConfig ? {
        options: [
            { label: "".concat(t('SELECT'), "\u2026"), value: 'choose' },
            { label: t('SETTINGS_VIDEO_MODE_DEFAULT'), value: 'default' },
        ],
        title: path !== null && path !== void 0 ? path : t('SETTINGS_VIDEO_MODE_DEFAULT'),
        disabled: choosing,
        onSelect: onSelect,
    } : null;
};
exports.default = useMpvConfig;
